import { AxiosRequestConfig, AxiosResponse } from 'axios'

import { useCallback, useEffect, useState } from 'react'

import { ApiFuncParam, ApiRunFunc } from '@/modules'

import { useBaseAPI } from './baseApi.hook'

type UseQueryOutput<T> = [boolean, ApiRunFunc, T | undefined, Error | undefined, () => void]

export function useQuery<T = unknown>(url: string): UseQueryOutput<T> {
  const { instance, canceler } = useBaseAPI()

  const [isPending, setPending] = useState<boolean>(true)
  const [data, setData] = useState<T | undefined>(undefined)
  const [error, setError] = useState<Error | undefined>(undefined)

  const run = useCallback(
    (params?: ApiFuncParam) => {
      const config: AxiosRequestConfig = {}

      if (params) {
        config.params = params
      }

      setPending(true)

      instance
        .get(url, config)
        .then(({ data }: AxiosResponse<T>) => {
          setData(data)
          setError(undefined)
        })
        .catch((error: Error) => {
          setError(error)
          setData(undefined)
        })
        .finally(() => {
          setPending(false)
        })
    },
    [instance, url],
  )

  useEffect(() => {
    run()
  }, [run])

  return [isPending, run, data, error, canceler.abort]
}
